import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { DBLeadList } from "@/lib/db-types";

/** Alle leadlister (admin/DL). Få rader, så ingen paginering. Møtebookere har ikke tilgang (RLS). */
export function useLeadLists(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["lead-lists"],
    queryFn: async (): Promise<DBLeadList[]> => {
      const { data, error } = await supabase
        .from("lead_lists")
        .select("*")
        .order("priority", { ascending: true })
        .order("created_at", { ascending: false });
      if (error) throw error;
      return (data ?? []) as DBLeadList[];
    },
    enabled: options.enabled ?? true,
    staleTime: 60 * 1000,
  });
}
